import { useEffect, useState } from "react";
import MobileSearchBar from "../../ui/MobileSearchBar";
import MobileList from "../../ui/MobileList";
import MobileListItem from "../../ui/MobileListItem";
import MobileSkeleton from "../../ui/MobileSkeleton";
import MobileEmpty from "../../ui/MobileEmpty";
import MobileError from "../../ui/MobileError";
import { cashnator, formatarData } from "../../../components/utils/functions";
import { useTransactionsSearch } from "./useTransactionsSearch";
import { MobileTransactionDetailSheet } from "./MobileTransactionDetailSheet";

function transactionSubtitle(transaction) {
  const value = cashnator(transaction?.product?.finalPrice);
  const email = transaction?.user?.email ?? "";
  const status = transaction?.data?.status ?? "";
  const date = transaction?.data?.received_at
    ? formatarData(transaction.data.received_at)
    : "";
  return [value, email, status, date].filter(Boolean).join(" · ");
}

export default function MobileTransactionsList({ user }) {
  const { transactions, loading, error, filters, setFilters, search, refresh } =
    useTransactionsSearch(user);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  useEffect(() => {
    setHasSearched(true);
    search();
  }, [search]);

  const handleSearch = (rawQ) => {
    const q = typeof rawQ === "string" ? rawQ : "";
    const next = { ...filters, q };
    setFilters(next);
    setHasSearched(true);
    search(next);
  };

  const openDetail = (transaction) => {
    setSelectedTransaction(transaction);
    setDetailOpen(true);
  };

  const closeDetail = () => {
    setDetailOpen(false);
    setSelectedTransaction(null);
  };

  const searchLabel = filters.q?.trim() ? "Pesquisar" : "Pesquisar todos";

  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-2 border-b border-primary/30 bg-mgs-bg px-4 py-2">
        <button
          type="button"
          onClick={() => {
            setHasSearched(true);
            refresh();
          }}
          className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-primary/50 px-3 text-sm font-medium text-laranjinha/80 hover:bg-monao"
        >
          Atualizar
        </button>
      </div>

      <MobileSearchBar
        value={filters.q}
        onChange={(q) => setFilters((current) => ({ ...current, q }))}
        onSubmit={handleSearch}
        submitLabel={searchLabel}
        placeholder="Nome, e-mail ou ID do pedido"
      />

      {loading ? (
        <div aria-label="Carregando transações" role="status">
          <MobileSkeleton lines={5} />
        </div>
      ) : error ? (
        <MobileError
          message={error.message ?? "Erro ao buscar transações."}
          onRetry={refresh}
        />
      ) : hasSearched && transactions.length === 0 ? (
        <MobileEmpty
          title="Nenhuma transação encontrada"
          message={
            filters.q?.trim()
              ? `Nenhum resultado para “${filters.q.trim()}”.`
              : "Ajuste a pesquisa ou toque em Pesquisar para buscar."
          }
        />
      ) : transactions.length > 0 ? (
        <MobileList>
          {transactions.map((item) => (
            <MobileListItem
              key={item._id}
              title={item.product?._id ?? item._id}
              subtitle={transactionSubtitle(item)}
              onClick={() => openDetail(item)}
            />
          ))}
        </MobileList>
      ) : null}

      <MobileTransactionDetailSheet
        open={detailOpen}
        onClose={closeDetail}
        transaction={selectedTransaction}
      />
    </div>
  );
}
